// vendors
import React from "react"

const IconFacebook = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.82 37.82" {...props}>
    <path d="M18.91,0A18.91,18.91,0,1,0,37.82,18.91,18.91,18.91,0,0,0,18.91,0Zm5.75,11.26H21.88a1.22,1.22,0,0,0-1.11,1v2.88h3.89c-.16,2.21-.48,4.23-.48,4.23H20.75V31H15.64V19.38H13.16V15.17h2.48V11.72c0-.63-.12-4.85,5.24-4.85h3.78Z" />
  </svg>
)

export default IconFacebook
